/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAgencyEmployeeRequest
 */
export interface UpdateAgencyEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAgencyEmployeeRequest
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgencyEmployeeRequest
     */
    lastname: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgencyEmployeeRequest
     */
    externalId?: string;
}

/**
 * Check if a given object implements the UpdateAgencyEmployeeRequest interface.
 */
export function instanceOfUpdateAgencyEmployeeRequest(value: object): value is UpdateAgencyEmployeeRequest {
    if (!('firstname' in value) || value['firstname'] === undefined) return false;
    if (!('lastname' in value) || value['lastname'] === undefined) return false;
    return true;
}

export function UpdateAgencyEmployeeRequestFromJSON(json: any): UpdateAgencyEmployeeRequest {
    return UpdateAgencyEmployeeRequestFromJSONTyped(json, false);
}

export function UpdateAgencyEmployeeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAgencyEmployeeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstname': json['firstname'],
        'lastname': json['lastname'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
    };
}

export function UpdateAgencyEmployeeRequestToJSON(value?: UpdateAgencyEmployeeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'externalId': value['externalId'],
    };
}

